import { useState } from "react";
import { Badge, Col, Row } from "react-bootstrap";
import { CommonButton, CommonInput } from "../../Input";
import DataTable from "../../table/DataTable";
import { showNotification } from "../../Common/CommonNotification";

const Step1CustomerSelection = ({ selectedCustomer, onSelectCustomer }) => {
  const mockData = [
    {
      id: "10844",
      name: "SparkMinds Technology Pte Ltd",
      type: "Organization",
      email: "checkpast12month@yopmail.com",
      phone: "+84 765161894",
      idCard: "S1234567A013",
      availableBalance: "111,604.9 SGD\n0 USD",
      pendingBalance: "0 SGD\n0 USD",
      status: "ACTIVATED",
      kycStatus: "APPROVED",
      createdTime: "06/03/2026\n18:23:59",
    },
    {
      id: "10843",
      name: "Thuy Nga Phan",
      type: "Individual",
      email: "checkpast12month@yopmail.com",
      phone: "+84 789908092",
      idCard: "check12month",
      availableBalance: "969 SGD\n0 USD",
      pendingBalance: "7,031.05 SGD\n11 USD",
      status: "ACTIVATED",
      kycStatus: "APPROVED",
      createdTime: "06/03/2026\n11:38:29",
    },
    {
      id: "10842",
      name: "idjaoida",
      type: "Organization",
      email: "judhuiajhdoa@yopmail.com",
      phone: "+65 93213213",
      idCard: "154651651",
      availableBalance: "--",
      pendingBalance: "--",
      status: "ACTIVATED",
      kycStatus: "PENDING",
      createdTime: "05/03/2026\n10:41:31",
    },
    {
      id: "10841",
      name: "mani",
      type: "Organization",
      email: "manicure@yopmail.com",
      phone: "+65 96533256",
      idCard: "mniii889",
      availableBalance: "--",
      pendingBalance: "--",
      status: "ACTIVATED",
      kycStatus: "PENDING",
      createdTime: "04/03/2026\n16:42:24",
    },
    {
      id: "10840",
      name: "dynamite org",
      type: "Organization",
      email: "dynamite@yopmail.com",
      phone: "+65 12345678933",
      idCard: "123123113",
      availableBalance: "--",
      pendingBalance: "--",
      status: "ACTIVATED",
      kycStatus: "PENDING",
      createdTime: "04/03/2026\n15:03:44",
    },
    {
      id: "10839",
      name: "dinh phong check entity",
      type: "Organization",
      email: "dinhphong01@yopmail.com",
      phone: "+65 12223456789",
      idCard: "dddd",
      availableBalance: "--",
      pendingBalance: "--",
      status: "ACTIVATED",
      kycStatus: "PENDING",
      createdTime: "04/03/2026\n14:45:34",
    },
    {
      id: "10838",
      name: "asdad",
      type: "Organization",
      email: "asdasd@sadasd.qq",
      phone: "+65 33124214",
      idCard: "1241",
      availableBalance: "--",
      pendingBalance: "--",
      status: "ACTIVATED",
      kycStatus: "PENDING",
      createdTime: "04/03/2026\n14:44:11",
    },
  ];
  const [filters, setFilters] = useState({
    name: "",
    idCard: "",
    phone: "",
    email: "",
  });
  const [filteredData, setFilteredData] = useState(mockData);

  const handleSearch = () => {
    const result = mockData.filter((item) => {
      const matchName = filters.name
        ? item.name.toLowerCase().includes(filters.name.toLowerCase())
        : true;
      const matchId = filters.idCard
        ? item.idCard.toLowerCase().includes(filters.idCard.toLowerCase())
        : true;
      const matchPhone = filters.phone
        ? item.phone.toLowerCase().includes(filters.phone.toLowerCase())
        : true;
      const matchEmail = filters.email
        ? item.email.toLowerCase().includes(filters.email.toLowerCase())
        : true;

      return matchName && matchId && matchPhone && matchEmail;
    });
    setFilteredData(result);
  };

  const handleReset = () => {
    setFilters({ name: "", idCard: "", phone: "", email: "" });
    setFilteredData(mockData);
  };
  const columns = [
    {
      label: "User ID",
      key: "id",
      style: { minWidth: "120px" },
      cellClassName: "align-middle fw-bold text-black",
    },
    {
      label: "Name",
      key: "name",
      style: { minWidth: "200px" },
      cellClassName: "align-middle",
      render: (item) => (
        <span className="fw-medium text-black">{item.name}</span>
      ),
    },
    {
      label: "Type",
      key: "type",
      style: { minWidth: "120px" },
      cellClassName: "align-middle",
      render: (item) => (
        <Badge
          className="fw-bold px-3 py-1"
          bg={item.type === "Organization" ? "dark" : "light"}
          style={{
            color: item.type === "Organization" ? "#fff" : "#475467",
            borderRadius: "20px",
            fontSize: "11px",
            backgroundColor:
              item.type !== "Organization" ? "#F2F4F7" : undefined,
          }}
        >
          {item.type}
        </Badge>
      ),
    },
    {
      label: "Email",
      key: "email",
      style: { minWidth: "200px" },
      cellClassName: "align-middle text-black",
    },
    {
      label: "Phone Number",
      key: "phone",
      style: { minWidth: "140px" },
      cellClassName: "align-middle text-black",
    },
    {
      label: "ID Card Number",
      key: "idCard",
      style: { minWidth: "140px" },
      cellClassName: "align-middle text-black",
    },
    {
      label: "Available balance",
      key: "availableBalance",
      style: { minWidth: "160px" },
      cellStyle: () => ({ whiteSpace: "pre-line" }),
      cellClassName: "align-middle text-black text-end pe-4 fw-medium",
    },
    {
      label: "Pending balance",
      key: "pendingBalance",
      style: { minWidth: "160px" },
      cellStyle: () => ({ whiteSpace: "pre-line" }),
      cellClassName: "align-middle text-black text-end pe-4 fw-medium",
    },
    {
      label: "Status",
      key: "status",
      style: { minWidth: "120px" },
      cellClassName: "align-middle",
      render: (item) => (
        <span
          className="px-3 py-1 fw-bold d-inline-block"
          style={{
            backgroundColor: "#E1F9ED",
            color: "#28C76F",
            borderRadius: "20px",
            fontSize: "11px",
            textTransform: "uppercase",
          }}
        >
          {item.status}
        </span>
      ),
    },
    {
      label: "KYC Status",
      key: "kycStatus",
      style: { minWidth: "120px" },
      cellClassName: "align-middle",
      render: (item) => (
        <span
          className="px-3 py-1 fw-bold d-inline-block"
          style={{
            backgroundColor:
              item.kycStatus === "APPROVED" ? "#E1F9ED" : "#FFF3E0",
            color: item.kycStatus === "APPROVED" ? "#28C76F" : "#FF9F43",
            borderRadius: "20px",
            fontSize: "11px",
            textTransform: "uppercase",
          }}
        >
          {item.kycStatus}
        </span>
      ),
    },
    {
      label: "Created Time",
      key: "createdTime",
      style: { minWidth: "120px" },
      cellStyle: () => ({ whiteSpace: "pre-line" }),
      cellClassName: "align-middle text-muted fs-12",
    },
  ];

  return (
    <>
      <Row className="g-2 mb-4 align-items-center">
        <Col xl className="col-lg-3 col-md-4 col-sm-6">
          <CommonInput
            placeholder="Enter name"
            value={filters.name}
            onChange={(e) => setFilters({ ...filters, name: e.target.value })}
          />
        </Col>
        <Col xl className="col-lg-3 col-md-4 col-sm-6">
          <CommonInput
            placeholder="Enter ID Card No"
            value={filters.idCard}
            onChange={(e) => setFilters({ ...filters, idCard: e.target.value })}
          />
        </Col>
        <Col xl className="col-lg-3 col-md-4 col-sm-6">
          <CommonInput
            placeholder="Enter phone"
            value={filters.phone}
            onChange={(e) => setFilters({ ...filters, phone: e.target.value })}
          />
        </Col>
        <Col xl className="col-lg-3 col-md-4 col-sm-6">
          <CommonInput
            placeholder="Enter email"
            value={filters.email}
            onChange={(e) => setFilters({ ...filters, email: e.target.value })}
          />
        </Col>
        <Col xl="auto" className="col-lg-auto col-md-12 col-sm-12 text-end">
          <div className="d-flex gap-2 justify-content-end">
            <CommonButton
              variant="outline"
              className="p-0 d-flex align-items-center justify-content-center"
              style={{ width: "38px", height: "38px" }}
              onClick={handleReset}
            >
              <i className="flaticon-381-repeat-1"></i>
            </CommonButton>
            <CommonButton
              className="p-0 d-flex align-items-center justify-content-center"
              style={{
                width: "38px",
                height: "38px",
                backgroundColor: "var(--primary)",
              }}
              onClick={handleSearch}
            >
              <i className="fa fa-search text-white"></i>
            </CommonButton>
          </div>
        </Col>
      </Row>

      <div className="card border-0 shadow-sm rounded-4 mb-4">
        <div className="card-body">
          <DataTable
            columns={columns}
            data={filteredData}
            showPagination={false}
            rowClassName={(item) =>
              selectedCustomer && selectedCustomer.id === item.id
                ? "bg-light-blue cursor-pointer"
                : "cursor-pointer"
            }
            onRowClick={(item) => {
              if (item.kycStatus === "APPROVED") {
                onSelectCustomer(item);
              } else {
                showNotification(
                  "This customer's KYC is not approved yet.",
                  "error",
                );
              }
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Step1CustomerSelection;
